import { render } from "./AboutCyprus.vue?vue&type=template&id=243d1b26&lang=pug"
import script from "./AboutCyprus.vue?vue&type=script&lang=js"
export * from "./AboutCyprus.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__